/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey =
  (
    discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams["discountTypeId"],
  ) =>
    [
      {
        url: "/api/v1/individualpayment/editors/discount-types/:discountTypeId/retroactive",
        params: { discountTypeId: discountTypeId },
      },
    ] as const;

export type GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey
  >;

export function getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryOptions(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams["discountTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey(
      discountTypeId,
    );
  return queryOptions<
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500
    >,
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
    typeof queryKey
  >({
    enabled: !!discountTypeId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive(
        discountTypeId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado RegistryAsync/GetRetroactiveDiscount. **(Requer Authorization para autenticação)**
 * @summary Indicador de desconto retroativo do tipo de desconto (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types/:discountTypeId/retroactive}
 */
export function useGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive<
  TData =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey,
>(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams["discountTypeId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401
          | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryKey(
      discountTypeId,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryOptions(
        discountTypeId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
